import { apiService } from "~/services/api";
import type { ITrip, ITripDetailResponse, ITripResponse } from "~~/types/liveTracking/3pl.interface"
import type { ITripReport } from "~~/types/liveTracking/report.interface";
import { useThreepl } from "../Tracking/handlers/useThreepl";

// const dummyData: ITripResponse = {
//     totalTrip: 25,
//     trips: [
//         { id: "K446-20260223-1", name: "Trip 1 - Feb 23", orderCount: 1, orderNo: "GK-11-603152580", shipmentNo: "S-001", courierName: "Dzulkifli Syukur", courierImageUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Dzulkifli", plateNumber: "B-1234-AB", originalStatus: "allocated", tripStatus: 1206 },
//         { id: "K446-20260223-2", name: "Trip 2 - Feb 23", orderCount: 3, orderNo: "GK-11-002", shipmentNo: "S-002", courierName: "Sintia Putri", courierImageUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Sintia", plateNumber: "B-2222-SNT", originalStatus: "allocated", tripStatus: 1207 },
//         { id: "K446-20260223-3", name: "Trip 3 - Feb 23", orderCount: 2, orderNo: "GK-11-003", shipmentNo: "S-003", courierName: "Akbar Ramadhan", courierImageUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Akbar", plateNumber: "B-3333-AKB", originalStatus: "allocated", tripStatus: 1204 },
//         { id: "K446-20260224-4", name: "Trip 4 - Feb 24", orderCount: 5, orderNo: "GK-11-004", shipmentNo: "S-004", courierName: "Budi Reborn", courierImageUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Budi", plateNumber: "B-4444-BUD", originalStatus: "allocated", tripStatus: 1207 },
//         { id: "K446-20260225-5", name: "Trip 5 - Feb 25", orderCount: 1, orderNo: "GK-11-005", shipmentNo: "S-005", courierName: "Susanto", courierImageUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Susanto", plateNumber: "B-5555-SAN", originalStatus: "unallocated", tripStatus: 1207 },
//         { id: "K446-006", name: "Trip 6 - Feb 26", orderCount: 2, orderNo: "GK-11-006", shipmentNo: "S-006", courierName: "Andi Wijaya", courierImageUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Andi", plateNumber: "B-6666-AND", originalStatus: "allocated", tripStatus: 1204 },
//         { id: "K446-007", name: "Trip 7 - Feb 26", orderCount: 4, orderNo: "GK-11-007", shipmentNo: "S-007", courierName: "Citra Lestari", courierImageUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Citra", plateNumber: "B-7777-CTR", originalStatus: "allocated", tripStatus: 1207 },
//         { id: "K446-008", name: "Trip 8 - Feb 26", orderCount: 1, orderNo: "GK-11-008", shipmentNo: "S-008", courierName: "Dedi Kurniawan", courierImageUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Dedi", plateNumber: "B-8888-DED", originalStatus: "unallocated", tripStatus: 1204 },
//         { id: "K446-009", name: "Trip 9 - Feb 27", orderCount: 3, orderNo: "GK-11-009", shipmentNo: "S-009", courierName: "Eka Saputra", courierImageUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Eka", plateNumber: "B-9999-EKA", originalStatus: "allocated", tripStatus: 1207 },
//         { id: "K446-010", name: "Trip 10 - Feb 27", orderCount: 2, orderNo: "GK-11-010", shipmentNo: "S-010", courierName: "Fani Rahayu", courierImageUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Fani", plateNumber: "B-1010-FAN", originalStatus: "allocated", tripStatus: 1204 },
//     ]
// };

// const detailDataMapper: Record<string, ITripDetailResponse> = {
//     "GK-11-603152580": {
//         id: "K446-20260223-1",
//         name: "Trip 1 - Feb 23",
//         orderNo: "GK-11-603152580",
//         orderCount: 1,
//         courierName: "Dzulkifli Syukur",
//         courierImageUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Dzulkifli",
//         courierPhoneNumber: "6287743432121",
//         plateNumber: "B-1234-AB",
//         originalStatus: "allocated",
//         tripStatus: 1206,
//         startTripTime: "10:00:00",
//         endTripTime: "",
//         totalDuration: 1.5,
//         shipments: [
//             {
//                 shipmentNo: "S-170825-FJWTK",
//                 customerName: "Almira Kusuma",
//                 address: "Jl. Palem Raya Blok i No.1, Tangerang Selatan",
//                 podImageUrl: "https://via.placeholder.com/150",
//                 status: 1106
//             }
//         ]
//     },
//     "GK-11-002": {
//         id: "K446-20260223-2",
//         name: "Trip 2 - Feb 23",
//         orderNo: "GK-11-002",
//         orderCount: 3,
//         courierName: "Sintia Putri",
//         courierImageUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Sintia",
//         courierPhoneNumber: "628129999002",
//         plateNumber: "B-2222-SNT",
//         originalStatus: "allocated",
//         tripStatus: 1207,
//         startTripTime: "",
//         endTripTime: "",
//         totalDuration: 0,
//         shipments: [
//             {
//                 shipmentNo: "S-190926-AAAAA",
//                 customerName: "Budi Reborn",
//                 address: "Jl. Sudirman No. 10, Jakarta Pusat",
//                 podImageUrl: "-",
//                 status: 1107
//             }
//         ]
//     },
//     "GK-11-003": {
//         id: "K446-20260223-3",
//         name: "Trip 3 - Feb 23",
//         orderNo: "GK-11-003",
//         orderCount: 2,
//         courierName: "Akbar Ramadhan",
//         courierImageUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Akbar",
//         courierPhoneNumber: "628129999003",
//         plateNumber: "B-3333-AKB",
//         originalStatus: "allocated",
//         tripStatus: 1204,
//         startTripTime: "09:15:00",
//         endTripTime: "",
//         totalDuration: 2.1,
//         shipments: [
//             {
//                 shipmentNo: "S-190926-BBBBB",
//                 customerName: "Sari Ati",
//                 address: "Taman Palem Blok B10, Cengkareng",
//                 podImageUrl: "-",
//                 status: 1104
//             }
//         ]
//     }
// };

const { isLoading, incrementLoading, decrementLoading } = useLoadingState();
const { member } = useMember()

// section state
const detailTrip = useState<ITripDetailResponse | null>('detail-trip-3pl', () => null)
const reportData = useState<ITripReport[] | null>('reports-data-3pl', () => null);
const statusTrip = ref<string>("all");
const trips = useState<ITrip[] | null>('list-trips-3pl', () => null)
const searchCrew = ref<string>("");
const hasMoreData = ref(true);
const isFilterApply = ref(false)
const detailTripId = ref<string>('')
const lastParams = ref<Record<string, any>>({});

const dateFilter = ref<{ start: Date, end: Date }>({
    start: getDaysAgo(6),
    end: getToday(),
})

const page = ref(1);
const limit = ref(100);

// SECTION Function helper
function getToday() {
    const d = new Date()
    d.setHours(0, 0, 0, 0)
    return d
}

function getDaysAgo(days: number) {
    const d = getToday()
    d.setDate(d.getDate() - days)
    return d
}

function formatDate(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};


// section store
export const useThreeeplStore = () => {

    // SECTION: --- GETTERS (Computed) ---
    const _searchCrew = computed({
        get: () => searchCrew.value,
        set: (newValue: string) => {
            searchCrew.value = newValue.toUpperCase();
        }
    });

    const isErrorDate = computed(() => {
        const start = new Date(dateFilter.value.start)
        const end = new Date(dateFilter.value.end)
        start.setHours(0, 0, 0, 0)
        end.setHours(0, 0, 0, 0)

        const diffTime = end.getTime() - start.getTime()
        const diffDays = diffTime / (1000 * 60 * 60 * 24)
        return diffDays > 6
    })

    const filteredTrips = computed(() => {
        let filterResult = [...(trips.value || [])]
        if (statusTrip.value === "all") {
            filterResult = filterResult
        }
        if (statusTrip.value !== "all") {
            const statusNumber = Number(statusTrip.value)
            filterResult = filterResult.filter(t => {
                return t.tripStatus === statusNumber
            })
        }

        const query = searchCrew.value.trim().toLowerCase()

        if (query.length >= 3) {
            filterResult = filterResult.filter((trip) => {
                const driverName = trip.courierName?.toLowerCase() || "";
                const plateNumber = trip.plateNumber?.toLowerCase() || "";
                return driverName.includes(query) || plateNumber.includes(query);;
            });
        }
        else if (query.length > 0 && query.length < 3) {
            return [];
        }

        return filterResult;
    });

    // SECTION: --- ACTIONS (Functions) ---

    function applyFilter3plReport() {
        if (isErrorDate.value) {
            return
        }
        const params: Record<string, any> = {
            storeCode: member.value?.storeCode,
            startDate: formatDate(dateFilter.value.start),
            endDate: formatDate(dateFilter.value.end),
        };
        fetchReport3pl(params, true);
        const { isModalTrackingFilter } = useThreepl()
        isModalTrackingFilter.value = false
        isFilterApply.value = true
    }

    function resetTrips() {
        trips.value = null;
        page.value = 1;
        limit.value = 100;
        hasMoreData.value = true;
    }

    function clearDateFilter() {
        dateFilter.value = {
            start: getDaysAgo(6),
            end: getToday(),
        }
        if (isFilterApply.value) {
            const params: Record<string, any> = {
                storeCode: member.value?.storeCode,
                startDate: formatDate(dateFilter.value.start),
                endDate: formatDate(dateFilter.value.end),
            };
            fetchReport3pl(params, true)
        }
        isFilterApply.value = false

    }

    async function fetchTrip3pl(params?: Record<string, any>, resetPagination: boolean = false): Promise<{ success: boolean, error?: Object }> {
        if (resetPagination) {
            page.value = 1;
            trips.value = [];
            hasMoreData.value = true;
        }

        if (isLoading.value || !hasMoreData.value) {
            return { success: false };
        }

        const fetchParams = {
            ...params,
            page: page.value,
            size: limit.value,
        };

        incrementLoading();

        const { data, error } = await apiService.tracking.trip3pl(fetchParams)

        if (error) {
            const errorDetail = error as ITripResponse;
            const errorMessage = errorDetail.error?.error
            hasMoreData.value = false;
            decrementLoading()
            return { success: false, error: errorMessage };

            // --- LOGIKA INFINITE SCROLL DUMMY-- -

            // const start = (page.value - 1) * limit.value;
            // const end = start + limit.value;
            // const slicedDummy = dummyData.trips.slice(start, end);

            // if (slicedDummy.length > 0) {
            //     trips.value = [...(trips.value || []), ...slicedDummy];
            //     page.value++;

            //     // Cek apakah data di array dummy sudah habis diambil semua
            //     if (trips.value.length >= dummyData.totalTrip || slicedDummy.length < limit.value) {
            //         hasMoreData.value = false;
            //     }
            // } else {
            //     hasMoreData.value = false;
            // }
            // decrementLoading()

            // return { success: false, error: 'Something when wrong' };

        }
        if (data && data.trips) {
            const mutatedTrips = data.trips.map((trip: ITrip) => {
                if (trip.originalStatus === 'confirmed') {
                    return {
                        ...trip,
                        courierName: trip.courierName || 'Mencari Rider 3PL ...',
                        courierImageUrl: ''
                    };
                }
                return trip;
            });
            trips.value = [...(trips.value || []), ...mutatedTrips];
            page.value++;

            if (trips.value.length >= data.totalTrip || data.trips.length < limit.value) {
                hasMoreData.value = false;
            }
        } else {
            hasMoreData.value = false;
        }

        decrementLoading()

        return { success: true }
    }

    function loadMoreTrips() {
        if (!hasMoreData.value) {
            return;
        }

        const STATUS_TO_STRING: Record<string, string> = {
            "1204": "Arrived",
            "1206": "ReadyToDeliver",
            "1207": "Delivering",
        };

        const params: Record<string, any> = {
            storeCode: member.value?.storeCode,
        };

        if (searchCrew.value && searchCrew.value.length >= 3) {
            params.search = searchCrew.value;
        }

        if (statusTrip.value !== "all") {
            const statusLabel = STATUS_TO_STRING[statusTrip.value] || statusTrip.value;
            params.status = statusLabel;
        }

        fetchTrip3pl(params);
    };

    async function fetchDetailTrip(tripId: string): Promise<{ success: boolean, error?: string }> {
        detailTrip.value = null
        if (isLoading.value) {
            return { success: false };
        }

        const { data, error } = await apiService.tracking.detail3pl(tripId)

        if (error || !data) {
            if (error) {
                const errorDetail = error as ITripDetailResponse;
                const message = errorDetail.error?.error || '';

                if (message.includes('TRIP_3PL_CHANGED_TO_INTERNAL')) {
                    if (trips.value) {
                        trips.value = trips.value.filter(t => t.id !== tripId);
                    }
                    detailTrip.value = null;
                    return { success: false, error: 'TRIP_3PL_CHANGED_TO_INTERNAL' };
                }

                return { success: false, error: message };
            }
        }

        if (data) {
            let finalData = { ...data };
            if (data.originalStatus === 'confirmed') {
                finalData = {
                    ...finalData,
                    courierName: data.courierName || 'Mencari ulang rider 3PL ...',
                    plateNumber: data.plateNumber || '-',
                    courierImageUrl: '',
                    startTripTime: '-',
                    endTripTime: '-',
                    totalDuration: '-',
                    courierPhoneNumber: '-'
                };
            } else {
                finalData = {
                    ...finalData,
                    courierName: data.courierName || '-',
                    plateNumber: data.plateNumber || '-',
                    startTripTime: data.startTripTime || '-',
                    endTripTime: data.endTripTime || '-',
                    totalDuration: data.totalDuration || '-',
                    courierPhoneNumber: data.courierPhoneNumber || '-'
                };
            }
            detailTrip.value = finalData
            detailTripId.value = finalData.id

            if (trips.value) {
                const index = trips.value.findIndex((t) => t.id === tripId);
                if (index !== -1) {
                    trips.value[index] = {
                        ...trips.value[index],
                        courierName: data.originalStatus === 'confirmed'
                            ? (data.courierName || 'Mencari Rider 3PL ...')
                            : (data.courierName || '-'),
                        courierImageUrl: finalData.courierImageUrl,
                        originalStatus: finalData.originalStatus,
                        plateNumber: finalData.plateNumber,
                        tripStatus: finalData.tripStatus
                    };
                }
            }
        }

        return { success: true }
    }

    async function fetchReport3pl(params?: Record<string, any>, resetPagination: boolean = false): Promise<{ success: boolean, error?: string }> {
        if (params) {
            lastParams.value = params;
        }

        if (resetPagination) {
            page.value = 1;
            hasMoreData.value = true;
            reportData.value = null;
        }

        if (isLoading.value || !hasMoreData.value) return { success: false };

        incrementLoading();

        const fetchParams = {
            ...params,
            page: page.value,
            size: 20,
        };

        const { data, error } = await apiService.tracking.report3pl(fetchParams)

        if (error || !data) {
            hasMoreData.value = false;
            decrementLoading()
            return { success: false, error: 'Something when wrong' };
        }

        if (data && data.length > 0) {
            reportData.value = page.value === 1
                ? data
                : [...(reportData.value || []), ...data];

            page.value++;

            if (data.length < 20) {
                hasMoreData.value = false;
            }
        } else {
            hasMoreData.value = false;
        }

        decrementLoading()

        return { success: true }
    }

    const loadMoreTripsReport = () => {
        if (!hasMoreData.value) {
            return;
        }
        fetchReport3pl(lastParams.value)
    };

    // SECTION: --- Lifecycle (Hook) ---
    watch(statusTrip, () => {
        detailTrip.value = null;
        detailTripId.value = '';
    });

    watch(searchCrew, () => {
        detailTripId.value = '';
        detailTrip.value = null;
    });

    return {
        trips: filteredTrips,
        detailTrip,
        statusTrip,
        _searchCrew,
        searchCrew,
        filteredTrips,
        applyFilter3plReport,
        dateFilter,
        getToday,
        getDaysAgo,
        isErrorDate,
        fetchTrip3pl,
        loadMoreTrips,
        hasMoreData,
        resetTrips,
        fetchDetailTrip,
        fetchReport3pl,
        reportData,
        clearDate: clearDateFilter,
        isFilterApply,
        detailTripId,
        loadMoreTripsReport
    }
}

